import { render, staticRenderFns } from "./ConfigChecklistInput.vue?vue&type=template&id=5979ec63&"
import script from "./ConfigChecklistInput.vue?vue&type=script&lang=js&"
export * from "./ConfigChecklistInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports